import useConfirmOnLeave from "@/helper/customHooks/useConfirmOnLeave";

interface Props {
  hasUnsavedChanges: boolean;
}

export default function UnsavedChangesLeaveGuard({ hasUnsavedChanges }: Props) {
  useConfirmOnLeave(hasUnsavedChanges, "unsaved_formChanges_confirm");
  return null;
}
